// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-hero-image-full/banner-hero-image-full.component.scss
// module id = 133
// module chunks = 0